var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 298.04"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.08 70.78c-16.17-16.24-16.09-42.54.15-58.7 16.25-16.17 42.54-16.09 58.71.15L256 197.76 441.06 12.23c16.17-16.24 42.46-16.32 58.71-.15 16.24 16.16 16.32 42.46.15 58.7L285.27 285.96c-16.24 16.17-42.54 16.09-58.7-.15L12.08 70.78z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iMjk4IiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiIgdGV4dC1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiIgaW1hZ2UtcmVuZGVyaW5nPSJvcHRpbWl6ZVF1YWxpdHkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiB2aWV3Qm94PSIwIDAgNTEyIDI5OC4wNCI+PHBhdGggZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTIuMDggNzAuNzhjLTE2LjE3LTE2LjI0LTE2LjA5LTQyLjU0LjE1LTU4LjcgMTYuMjUtMTYuMTcgNDIuNTQtMTYuMDkgNTguNzEuMTVMMjU2IDE5Ny43NiA0NDEuMDYgMTIuMjNjMTYuMTctMTYuMjQgNDIuNDYtMTYuMzIgNTguNzEtLjE1IDE2LjI0IDE2LjE2IDE2LjMyIDQyLjQ2LjE1IDU4LjdMMjg1LjI3IDI4NS45NmMtMTYuMjQgMTYuMTctNDIuNTQgMTYuMDktNTguNy0uMTVMMTIuMDggNzAuNzh6Ii8+PC9zdmc+";
export { SvgChevronDown as ReactComponent };